import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useReportViewOptions = (presetId) => {
  return useMutation({
    mutationFn: (data) => {
      const query = encodeData({ ...(presetId && { data_filter: presetId }), ...data });
      return fetch({
        url: `${Angie.api_url}/reports/table-view-options?${query}`,
        method: "GET",
      });
    },
  });
};

export const useSaveReportViewOptions = (presetId) => {
  return useMutation({
    mutationFn: (data) => {
      return fetch({
        url: `${Angie.api_url}/reports/table-view-options`,
        method: "PUT",
        body: { ...(presetId && { data_filter: presetId }), ...data },
      });
    },
  });
};
